<template>
  <div class="min-h-screen" :class="[$theme.cardBg]">
    <div v-for="(tour, index) in tours" :key="index" :class="[
      index === active ? '' : 'hidden',
      'flex flex-col justify-between h-full'
    ]">
      <div class="px-6 pt-5 pb-28">
        <div class="flex">
          <div v-for="(t, i) in tours" :key="i" @click="onToSlide(i)" :class="[
            i === active ? $theme.inverseBaseBg : $theme.placeBg,
            'h-1 w-full mr-2'
          ]"></div>
        </div>

        <div class="text-4xl font-bold mt-10">{{ tour.title }}</div>
        <template v-if="tour.image">
          <div>
            <img :src="tour.image" class="w-full h-48 object-cover mt-7 rounded-xl">
          </div>
        </template>
        <div
          v-html="tour.description"
          class="mt-7 prose max-w-none"
          :class="[$theme.baseTextColor, `prose-strong:${$theme.baseTextColor}`]"
        ></div>
        <template v-if="tour.link_video">
          <iframe
              :src="youtubeEmbedUrl(tour.link_video)"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              class="w-full h-48 mt-4 rounded-lg"
          ></iframe>
        </template>
      </div>
      <div class="px-4 pb-6 fixed bottom-0 left-0 w-full">
        <template v-if="index < (tours.length - 1)">
          <div class="grid" :class="[active > 0 ? 'grid-cols-2 gap-4' : '']">
            <button
                v-if="active > 0"
                @click="onToSlide(active - 1)"
                type="button"
                class="w-full flex items-center justify-center border font-bold rounded-full px-4 py-2.5"
                :class="[
                    $theme.lightButtonBg,
                    $theme.lightButtonTextColor,
                    $theme.borderColorBtn,
                  ]"
            >
              {{ $t('prev') }}
            </button>
            <button
                @click="onNextSlide(index)"
                type="button"
                class="flex w-full items-center m-yellow-bg rounded-full text-black justify-center px-3 py-3 font-semibold"
                :class="[isFormProcessing ? 'opacity-50 pointer-events-none' : '']"
            >
              {{ $t('next') }}
            </button>
          </div>
        </template>
        <template v-else>
          <button
              @click="onFinishTour"
              type="button"
              class="flex w-full items-center m-yellow-bg rounded-full text-black justify-center px-3 py-3 font-semibold"
              :class="[isFormProcessing ? 'opacity-50 pointer-events-none' : '']"
          >
            <template v-if="isFormProcessing">
              <ButtonSpinner />
            </template>
            {{ $t('go_to_setup') }}
          </button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonSpinner from "@/components/ButtonSpinner.vue";

export default {
  components: {ButtonSpinner},
  data() {
    return {
      tours: [],
      active: 0,
      isFormProcessing: false,
    }
  },

  mounted() {
    this.updateRegStatus();
    this.loadTours();
  },

  methods: {
    youtubeEmbedUrl(url) {
      const videoIdMatch = url.match(
          /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&]+)/
      );
      const videoId = videoIdMatch ? videoIdMatch[1] : '';
      return `https://www.youtube.com/embed/${videoId}`;
    },

    onNextSlide(index) {
      this.active = index + 1;
    },

    onToSlide(index) {
      this.active = index;
    },

    onFinishTour() {
      this.isFormProcessing = true;

      this.$api.post('/user/apply-guide').then(result => {
        console.log('result', result);
        this.$emit('action-success', 1);
        this.isFormProcessing = false;
      });
    },

    updateRegStatus() {
      this.$api.post('/user/update-reg', {
        status: 'VIEW_GUIDE'
      }).then(() => {
      });
    },

    loadTours() {
      this.$api.get('/guide-tour').then((result) => {
        console.log(result.data.data)
        this.tours = result.data.data;
      }).catch(e => {
        alert(e.message)
        this.error = e
      })
    },
  }
}
</script>
